import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '@interfaces/api/api.interface';
import { SellerDataInterface } from '@interfaces/artisan/get_seller_data';
import { LanguageService } from '@core/services/language/language.service';

@Injectable({
  providedIn: 'root',
})
export class ArtisanService {
  private http = inject(HttpClient);
  private artisanEndpoint = environment.endpoints.sellers;
  private api = environment.API_URL;
  private locale = inject(LanguageService);

  public getArtisanInfo(sellerID: string): Observable<ApiResponse<SellerDataInterface>> {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('locale', this.locale.currentLanguage().toUpperCase());
    return this.http.get<ApiResponse<SellerDataInterface>>(`${this.api}/${this.artisanEndpoint}/${sellerID}`, {
      params: httpParams,
    });
  }
}
